/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/naming-convention */
// Package Imports
import { Injectable } from '@angular/core';

// Models
import { LocalData, UserSessionData } from '../../models';

// Configurations
import { AppConfigService } from '../app-config/app-config.service';
import { BehaviorSubject } from 'rxjs';
import { FeatureFlag } from '../../models/feature-flag/feature-flag';

@Injectable({
  providedIn: 'root'
})
export class SessionService {
  // Create constant variable here and use it instead of string in all over application.
  // This way we could avoid duplicate session key and avoid overwriting a value with duplicate key.
  sessionKey_UserSession = 'sessionKey_UserSession';
  sessionKey_AuthMetaData = 'sessionKey_AuthMetaData';
  sessionKey_BaseUrl = 'sessionKey_BaseUrl';
  sessionKey_KeepSessionAlive = 'sessionKey_KeepSessionAlive';
  sessionSubject$ = new BehaviorSubject<FeatureFlag[]>([]);

  constructor(private readonly appConfigService: AppConfigService) {
    const _usersessionData = this.getData(this.sessionKey_UserSession, sessionStorage);
    if (_usersessionData) {
      this.sessionSubject$.next(_usersessionData.featureFlags);
    }
   }

  // use this to store any data that is only related to logged in user
  storeSessionData(key: string, value: any): void {
    const date = new Date();
    let hoursToExpire = 6;

    if (this.appConfigService) {
      this.appConfigService.getData('sessionExpiration');
      if (!hoursToExpire) {
        hoursToExpire = 6;
      }
    }

    date.setTime(date.getTime() + hoursToExpire * 60 * 60 * 1000);
    this.storeData(key, value, date, sessionStorage);
  }

    pushFeature(flags: FeatureFlag[]): void {
    this.sessionSubject$.next(flags);
  }

  getSessionData(key: string): any {
    return this.getData(key, sessionStorage);
  }

  // use this to store any common data among users. Ex: lookup values
  storeLocalData(key: string, value: any): void {
    const date = new Date();
    let daysToExpire = 10;

    if (this.appConfigService) {
      this.appConfigService.getData('LocalDataExpiration');

      if (!daysToExpire) {
        daysToExpire = 10;
      }
    }

    date.setDate(date.getDate() + daysToExpire);
    this.storeLocalDataWithExpiration(key, value, date);
  }

  storeLocalDataWithExpiration(key: string, value: any, expiresOn: Date): void {
    this.storeData(key, value, expiresOn, localStorage);
  }

  clearSession(): void {
    sessionStorage.clear();
  }

  clearLocal(): void {
    localStorage.clear();
  }

  getLocalData(key: string): any {
    return this.getData(key, localStorage);
  }

  private getData(key: string, storage: Storage): any {
    try {
      const currentDate = new Date();
      const data = storage.getItem(key);

      if (data !== null && data !== undefined && data.indexOf('{') > -1) {
        const localData: LocalData<any> = JSON.parse(data);

        if (localData.expiresOn <= currentDate) {
          storage.removeItem(key);
        }
        else {
          return localData.data;
        }
      }
      else {
        return data;
      }
    }
    catch (e) { }

    return null;
  }

  private storeData(key: string, value: any, expiresOn: Date, storage: Storage): void {
    const localData = new LocalData<any>();

    localData.data = value;
    localData.expiresOn = expiresOn;
    storage.setItem(key, JSON.stringify(localData));
  }
}
